webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: "history",
  routes: [{
    path: "/",
    name: "Home",
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }]
}));

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(9)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(6),
  /* template */
  __webpack_require__(12),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_websocket__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_websocket___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_websocket__);






__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vue_websocket___default.a, window.location.protocol + "//" + window.location.host, {
  path: "/ws/socket.io"
});

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: "#app",
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: "<App/>",
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: "app"
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      assets: null,
      quotes: null,
      transactionHistory: null,
      connected: false,
      cashTotal: 0,
      portfolioTotal: 0,
      referralTotal: 0,
      minChangePercent: 0,
      maxChangePercent: 0,
      marketOpen: true,
      tradesRemaining: 0,
      totalTrades: 78
    };
  },

  methods: {
    assetChangePercentToColor: function assetChangePercentToColor(asset) {
      if (asset.averageCost <= 0) {
        return "#ffffff";
      } else if (asset.change < 0) {
        return "hsl(1,70%," + (100 - 35 * asset.changePercent / this.minChangePercent) + "%)";
      } else {
        return "hsl(120,50%," + (100 - 50 * asset.changePercent / this.maxChangePercent) + "%)";
      }
    },
    formatChange: function formatChange(change) {
      if (change == null) {
        return "------";
      } else if (change < 0) {
        return "-$" + Math.abs(change).toFixed(2);
      } else {
        return "+$" + change.toFixed(2);
      }
    },
    formatChangePercent: function formatChangePercent(change) {
      if (change == null) {
        return "------";
      } else if (change < 0) {
        return "-" + Math.abs(change).toFixed(2) + "%";
      } else {
        return "+" + change.toFixed(2) + "%";
      }
    },
    formatFinanceLink: function formatFinanceLink(symbol) {
      return "https://finance.yahoo.com/quote/" + symbol + "/";
    },
    formatPercent: function formatPercent(percent) {
      if (percent == null) {
        return "------";
      } else {
        return percent.toFixed(2) + "%";
      }
    },
    formatPrice: function formatPrice(price) {
      if (price == null) {
        return "------";
      } else {
        return "$" + price.toFixed(2);
      }
    }
  },
  socket: {
    events: {
      connect: function connect() {
        console.log("Connected");
        this.connected = true;
      },
      disconnect: function disconnect() {
        console.log("Disconnected");
        this.connected = false;
      },
      assets: function assets(msg) {
        var _this = this;

        this.cashTotal = msg.cashTotal;
        this.portfolioTotal = msg.portfolioTotal;
        this.referralTotal = msg.referralTotal;
        this.assets = msg.assets;

        this.minChangePercent = 0;
        this.maxChangePercent = 0;
        msg.assets.forEach(function (asset) {
          if (asset.averageCost > 0 && asset.changePercent < _this.minChangePercent) {
            _this.minChangePercent = asset.changePercent;
          }
          if (asset.averageCost > 0 && asset.changePercent > _this.maxChangePercent) {
            _this.maxChangePercent = asset.changePercent;
          }
        });
      },
      quotes: function quotes(msg) {
        this.quotes = msg.quotes;
      },
      transactionHistory: function transactionHistory(msg) {
        this.transactionHistory = msg.transactionHistory;
      },
      marketStateUpdate: function marketStateUpdate(msg) {
        this.marketOpen = msg.marketOpen;
        this.tradesRemaining = msg.tradesRemaining;
      }
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 9 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(8)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(7),
  /* template */
  __webpack_require__(11),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 11 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h3', [_vm._v("StockStream Live (Alpha)")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('hr'), _vm._v(" "), (!_vm.connected) ? _c('div', [_c('h4', [_vm._v("Connecting...")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row full-width"
  }, [_c('div', {
    staticClass: "col text-center"
  }, [_vm._m(2), _vm._v(" "), _c('p', {
    staticClass: "trades-remaining"
  }, [_vm._v(_vm._s(_vm.tradesRemaining) + " / " + _vm._s(_vm.totalTrades))])]), _vm._v(" "), (_vm.marketOpen) ? _c('div', {
    staticClass: "col"
  }, [_vm._m(3), _vm._v(" "), (_vm.transactionHistory && _vm.transactionHistory.length > 0) ? _c('div', {
    staticClass: "card"
  }, _vm._l((_vm.transactionHistory), function(transaction) {
    return _c('p', [_c('span', {
      domProps: {
        "textContent": _vm._s(transaction.type.toUpperCase())
      }
    }), _vm._v(" " + _vm._s(transaction.symbol) + " @ " + _vm._s(transaction.shares) + " x " + _vm._s(_vm.formatPrice(transaction.price)) + "\n        ")])
  })) : _c('div', {
    staticClass: "card"
  }, [_c('p', [_vm._v("No data yet")])])]) : _c('div', {
    staticClass: "col text-center"
  }, [_c('h3', [_vm._v("Market Closed")])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "compact"
  }, [_vm._v("Total: " + _vm._s(_vm.formatPrice(_vm.portfolioTotal + _vm.cashTotal)))]), _vm._v(" "), _c('p', {
    staticClass: "compact"
  }, [_vm._v("Cash: " + _vm._s(_vm.formatPrice(_vm.cashTotal)))])]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_c('p', {
    staticClass: "compact"
  }, [_vm._v("Portfolio: " + _vm._s(_vm.formatPrice(_vm.portfolioTotal)))])])])])]), _vm._v(" "), (_vm.assets) ? _c('div', [_vm._m(5), _vm._v(" "), _c('table', {
    staticClass: "bordered"
  }, [_vm._m(6), _vm._v(" "), _c('tbody', _vm._l((_vm.assets), function(asset) {
    return _c('tr', [_c('td', {
      staticClass: "symbol text-left"
    }, [_c('a', {
      attrs: {
        "href": _vm.formatFinanceLink(asset.symbol),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(asset.symbol))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(asset.shares))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(asset.averageCost)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(asset.currentCost)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatChange(asset.change)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right",
      style: ({
        backgroundColor: _vm.assetChangePercentToColor(asset)
      })
    }, [_vm._v(_vm._s(_vm.formatChangePercent(asset.changePercent)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(asset.paidTotal)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPrice(asset.currentTotal)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatChange(asset.totalChange)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_vm._v(_vm._s(_vm.formatPercent(asset.percentPortfolio)))])])
  }))])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Alpha site for a live-updating view of "), _c('a', {
    attrs: {
      "href": "https://www.twitch.tv/stockstream"
    }
  }, [_vm._v("StockStream")]), _vm._v("'s portfolio")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Historical data @ "), _c('a', {
    attrs: {
      "href": "https://stockstream.abal.moe/data"
    }
  }, [_vm._v("https://stockstream.abal.moe/data")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', [_vm._v("Trades Remaining")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Transaction History")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Portfolio Status")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Portfolio")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticClass: "symbol"
  }, [_vm._v("Symbol")]), _vm._v(" "), _c('th', [_vm._v("Shares")]), _vm._v(" "), _c('th', [_vm._v("Paid")]), _vm._v(" "), _c('th', [_vm._v("Current Price")]), _vm._v(" "), _c('th', [_vm._v("Change ($)")]), _vm._v(" "), _c('th', [_vm._v("Change (%)")]), _vm._v(" "), _c('th', [_vm._v("Paid Total")]), _vm._v(" "), _c('th', [_vm._v("Current Total")]), _vm._v(" "), _c('th', [_vm._v("Total Change")]), _vm._v(" "), _c('th', [_vm._v("% of Portfolio")])])])
}]}

/***/ }),
/* 12 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ })
],[5]);


// WEBPACK FOOTER //
// static/js/app.2e8699810b6888f64b28.js